import React from 'react';
import './MaintenancePage.css';

// メンテナンス中に App の代わりに表示する画面
// ビルド時の環境変数 REACT_APP_MAINTENANCE_MESSAGE があれば本文として表示する
const DEFAULT_MESSAGE =
  'ただいまシステムメンテナンスを実施しております。\nご不便をおかけして申し訳ございません。再開まで今しばらくお待ちください。';

function MaintenancePage() {
  const message = process.env.REACT_APP_MAINTENANCE_MESSAGE || DEFAULT_MESSAGE;

  return (
    <div className="maintenance">
      <div className="maintenance-card">
        <img className="maintenance-logo" src="/FACTime_logo_Black.png" alt="FACTime" />
        <div className="maintenance-icon" aria-hidden="true">🛠️</div>
        <h1 className="maintenance-title">メンテナンス中</h1>
        <p className="maintenance-message">{message}</p>
        <p className="maintenance-note">
          これまでに記録されたデータは保持されています。メンテナンス終了後に改めてアクセスしてください。
        </p>
      </div>
    </div>
  );
}

export default MaintenancePage;
